import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  top: 17px;
  left: 15px;
`;

export default Container;
